'use strict';

class UsersNewController {
  constructor($log,
              $q,
              $rootScope,
              $scope,
              $timeout,
              $filter,
              $state,
              $translate,
              utils,
              OrganizationService,
              UsersService,
              PermissionsService,
              LocationsService,
              config,
              AuthService,
              ToastsService) {

    // #region Define fields

    const $t = $filter('translate');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const CURRENT_ADMIN_LOCAL_STORAGE_KEY = 'App-Admin';
    const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';
    const SELECTED_ORG_LOCAL_STORAGE_KEY = 'Selected-Org';
    const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';
    const PWD_REGEX_KEY = 'Password-Regex';

    $scope.currentOrganization = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.sourceOrganization = utils.getStorageItem(SELECTED_ORG_LOCAL_STORAGE_KEY);
    $scope.selectedLocation = utils.getStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY);
    $scope.allOrganizations = utils.getStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY);
    $scope.currentUser = utils.getStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY);
    $scope.isSaveAttempt = false;

    $scope.phoneTypes = config.getConfigByKey('phoneTypes');
    $scope.locationsTypes = config.getLocationTypes();
    $scope.usagePeriods = config.getConfigByKey('usagePeriods');
    $scope.heatingTypes = config.getConfigByKey('heatingTypes');
    $scope.coolingTypes = config.getConfigByKey('coolingTypes');
    $scope.waterHeaterTypes = config.getConfigByKey('waterHeaterTypes');
    $scope.thermostatTypes = config.getConfigByKey('thermostatTypes');
    $scope.sizeTypes = [
      {
        'name': $t('locations.sizes.ft2'),
        'value': 'ft2'
      }, {
        'name': $t('locations.sizes.m2'),
        'value': 'm2'
      }
    ];

    const selection = ($state.params && $state.params.from) ? $state.params.from : void 0;
    const fromTab = ($state.params && $state.params.fromTab) ? $state.params.fromTab : void 0;

    $scope.createLocationUser = selection === 'location' && !!$scope.selectedLocation;
    $scope.canICreateAdmin = false;
    $scope.showSecurityError = false;
    $scope.uiStep = 'user';

    angular.extend($scope, {
      onSaveAdminUserButtonClick: onSaveAdminUserButtonClick,
      onSaveUserAndLocationButtonClick: onSaveUserAndLocationButtonClick,
      onSaveUserButtonClick: onSaveUserButtonClick,
      onNextStepButtonClick: onNextStepButtonClick,
      onPreviousStepButtonClick: onPreviousStepButtonClick,
      goBack: goBack,
    });

    // #endregion

    init();

    // #region Methods

    function init() {
      if (!PermissionsService.canICreateUserAndLocation()) {
        $scope.showSecurityError = true;
        return;
      }
      $scope.canICreateAdmin = PermissionsService.canICreateAdminUserInOrganization();

      // List of current organization and all child organizations
      let sourceOrg = $scope.sourceOrganization ? $scope.sourceOrganization : $scope.currentOrganization;
      $scope.organizations = utils.getChildOrganizations($scope.allOrganizations, sourceOrg.id) || [];
      $scope.organizations.unshift(sourceOrg);
      $scope.selectedOrganizationId = sourceOrg.id;
      $scope.selectedOrganization = sourceOrg;

      // Parse phone number from parameters
      const phoneInfo = utils.parsePhoneNumber($state.params.phone);

      $scope.user = {
        appName: utils.getAppName(),
        phoneType: 1,
        phoneCode: phoneInfo.phoneCode,
        phoneNumber: phoneInfo.phoneNumber,
        email: $state.params.email || undefined,
      };

      $scope.location = {
        // appName: utils.getAppName(),
        // state: {},
        // country: {}
        type: '10', // default Location type
        size: {
          unit: 'ft2' // default size type
        }
      };

      $scope.$watchGroup([
        'location.country.id',
        'selectedCountry',
        'countries'
      ], function() {
        changeCountry();
      });

      $scope.$watch('selectedUserRoleId', (newValue, oldValue) => {
        if (!!$scope.selectedUserRoleId) {
          $scope.user.phoneType = 1;
        }
        if (newValue !== oldValue) {
          triggerFormValidation();
        }
      });

      $scope.$watch('user.phoneCode', (newValue, oldValue) => {
        if (!$scope.isSaveAttempt) {
          return;
        }
        if (newValue !== oldValue) {
          triggerFormValidation();
        }
      });

      $scope.loading = true;
      return $q.all([
        initRoles(),
        initCountries(),
        initForms(),
        initPwdRegex()
      ])
        .then(() => $scope.loading = false, () => $scope.loading = false);
    }

    function initRoles() {
      if (!$scope.canICreateAdmin) {
        return $q.resolve();
      }
      return OrganizationService.getRoles()
        .then(data => {
            $scope.roles = data.roles;

            // Pre-select admin role
            if (selection === 'organization' && fromTab === 'admins') {
              $scope.selectedUserRoleId = $scope.roles && $scope.roles[0] ? $scope.roles[0].id : void 0;
            }
          },
          err => {
            utils.handleApiError(err);
          });
    }

    function initCountries() {
      return LocationsService.getCountries()
        .then(function(data) {
          $scope.countries = data.countries;
          return data;
        });
    }

    function initForms() {
      $.fn.form.settings.rules.zipRule = function(value) {
        if (!value) {
          return true;
        }
        if ($scope.selectedCountry && $scope.selectedCountry.zipFormat) {
          try {
            return new RegExp($scope.selectedCountry.zipFormat).test(value);
          } catch (err) {
            $log.warn(`Unable to parse ZIP code RegExp of country "${$scope.selectedCountry.name}": ${$scope.selectedCountry.zipFormat}`);
            $log.warn(err);
          }
        }
        return true;
      };

      $.fn.form.settings.rules.integerOrEmpty = function(value, n) {
        if (!value) {
          return true;
        }
        return $.fn.form.settings.rules.integer(value, n);
      };

      $.fn.form.settings.rules.emailOrEmpty = function(value) {
        if (!value) {
          return true;
        }
        return new RegExp(utils.emailRegexp()).test(value);
      };

      $.fn.form.settings.rules.numberOrEmpty = function(value, n) {
        if (!value) {
          return true;
        }
        let flag = $.fn.form.settings.rules.number(value);
        if (flag) {
          if (n) {
            let arr = n.split('..');
            let min = arr.length >= 1 ? Number(arr[0]) : Number.MIN_VALUE,
              max = arr.length >= 2 ? Number(arr[1]) : Number.MAX_VALUE,
              valNum = Number(value);
            return valNum >= min & valNum <= max;
          } else {
            return true;
          }
        }
        return false;
      };

      $.fn.form.settings.rules.emptyIfAdmin = function(value) {
        return !!$scope.selectedUserRoleId
          ? $.fn.form.settings.rules.empty(value)
          : true;
      };

      $.fn.form.settings.rules.phoneCode = function(value) {
        if (!!$scope.user.phoneNumber || !!$scope.user.phoneCode) {
          if (!$scope.user.phoneCode || $scope.user.phoneCode === '0' || !/^[0-9]{1,3}$/gi.test($scope.user.phoneCode)) {
            return false;
          }
        }
        return true;
      };

      $.fn.form.settings.rules.phoneNumber = function(value) {
        if (!!$scope.user.phoneNumber || !!$scope.user.phoneCode) {

          if (!$scope.user.phoneNumber || !/^[0-9]{7,14}$/gi.test($scope.user.phoneNumber)) {
            return false;
          }

          return $.fn.form.settings.rules.phoneValidation(
            $scope.user.phoneNumber,
            JSON.stringify({
              code: $scope.user.phoneCode.toString(),
              type: $scope.selectedPhoneType && $scope.selectedPhoneType.id
            })
          );
        }
        return true;
      };

      $('#user-form').form({
        inline: true,
        keyboardShortcuts: false,
        fields: {
          'firstName': {
            rules: [
              {
                type: 'empty',
                prompt: $t('users.new.errors.noFirstName')
              }
            ]
          },
          'email': {
            rules: [
              {
                type: 'emptyIfAdmin',
                prompt: $t('users.new.errors.noEmail')
              },
              {
                type: 'emailOrEmpty',
                prompt: $t('prompt.email.valid')
              }
            ]
          },
          'code': {
            depends: 'phone',
            rules: [
              {
                type: 'phoneCode',
                prompt: $t('prompt.signup.phone.code')
              }
            ]
          },
          'phone': {
            identifier: 'phone',
            rules: [
              {
                type: 'phoneNumber',
                prompt: $t('prompt.signup.phone.invalid')
              }
            ]
          }
        }
      });

      $('#location-form').form({
        inline: true,
        fields: {
          'name': {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.locations.name.empty')
              }
            ]
          },
          'zip': {
            rules: [
              {
                type: 'zipRule',
                prompt: $t('prompt.zip.reg')
              }
            ]
          }
        }
      });

      $('#location-form-2').form({
        inline: true,
        fields: {
          'latitude': {
            rules: [
              {
                type: 'numberOrEmpty[-90..90]',
                prompt: $t('prompt.locations.latitude')
              }
            ]
          },
          'longitude': {
            rules: [
              {
                type: 'numberOrEmpty[-180..180]',
                prompt: $t('prompt.locations.longitude')
              }
            ]
          },
          'size': {
            rules: [
              {
                type: 'numberOrEmpty',
                prompt: $t('prompt.locations.numberOrEmpty')
              }
            ]
          },
          'stories': {
            rules: [
              {
                type: 'integerOrEmpty',
                prompt: $t('prompt.locations.integerOrEmpty')
              }
            ]
          },
          'rooms': {
            rules: [
              {
                type: 'integerOrEmpty',
                prompt: $t('prompt.locations.integerOrEmpty')
              }
            ]
          },
          'bathrooms': {
            rules: [
              {
                type: 'integerOrEmpty',
                prompt: $t('prompt.locations.integerOrEmpty')
              }
            ]
          },
          'occupants': {
            rules: [
              {
                type: 'integerOrEmpty',
                prompt: $t('prompt.locations.integerOrEmpty')
              }
            ]
          }
        }
      });

      return $q.resolve();
    }

    function initPwdRegex() {
      let regex = utils.getStorageItem(PWD_REGEX_KEY);
      if (regex) {
        updateUserFormRules(regex);
        return;
      }

      return AuthService.getPasswordRegex()
        .then((data) => {
          utils.setStorageItem(PWD_REGEX_KEY, data);
          updateUserFormRules(data);
        });
    }

    function updateUserFormRules(regex) {
      // Combine Server regex and empty rule
      let newRegex = '^(?:' + regex.slice(1, -1) + '|)$';
      let fullRegex = new RegExp(newRegex);
      fullRegex = 'regExp[' + fullRegex + ']';

      $('#user-form').form('add rule', 'password', {
        rules: [
          {
            type: fullRegex,
            prompt: $t('users.new.form.passwordRegex')
          }
        ]
      });
    }

    function triggerFormValidation() {
      $('#user-form').form('validate form');
    }

    function changeCountry() {
      if (!$scope.selectedCountry) {
        $scope.states = undefined;
        return;
      }
      $scope.states = $scope.selectedCountry.states;
      if ($scope.states && $scope.states.length > 0) {
        $scope.location.state = { id: $scope.states[0].id };
        $scope.selectedState = $scope.states[0];
      } else {
        $scope.location.state = undefined;
        $scope.selectedState = undefined;
      }
    }

    function saveAdminUser() {
      if ($scope.loading) {
        return;
      }

      $scope.loading = true;
      let user = angular.copy($scope.user);
      const strongPassword = user.password ? true : false;
      user.username = user.username ? user.username : user.email;

      // Phone number parsing
      if (user.phoneNumber) {
        user.phone = user.phoneCode.toString() + user.phoneNumber.toString();
        user.phoneType = 1;
        delete user.phoneNumber;
      }
      delete user.phoneCode;

      if (user.password === '') {
        delete user.password;
      }

      let organizationId = $scope.selectedOrganizationId || $scope.currentOrganization.id;

      return UsersService.createNewUser({
        user: user
      }, strongPassword, organizationId || void 0)
        .then((result) => {
          user.id = result.userId;
          return OrganizationService.grantRoleToUser(user.id, $scope.selectedUserRoleId)
            .then(() => OrganizationService.addUserToOrgAdmins(organizationId, user.id))
            .then(() => {
              $scope.loading = false;
              ToastsService.success(null, $t('users.new.success-admin'));
              // Redirect to Edit Organization UI
              redirectToOrganization();
            }, (err) => {
              ToastsService.success(null, $t('users.new.success-admin-role'));
              $scope.loading = false;
              utils.handleApiError(err);
              // Redirect to Edit Organization UI
              redirectToOrganization();
            });
        })
        .catch((err) => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function saveLocationUser() {
      if ($scope.loading || !$scope.selectedLocation) {
        return;
      }

      $scope.loading = true;
      let user = angular.copy($scope.user);

      // Phone number parsing
      if (user.phoneNumber) {
        user.phone = user.phoneCode.toString() + user.phoneNumber.toString();
        user.phoneType = 1;
        delete user.phoneNumber;
      }
      delete user.phoneCode;

      if (user.password === '') {
        delete user.password;
      }
      let organizationId = $scope.selectedOrganizationId || $scope.currentOrganization.id;

      return UsersService.createNewUser({
        user: user,
      }, void 0, organizationId || void 0)
        .then((res) => LocationsService.addLocationUser($scope.selectedLocation.id, res.userId))
        .then(() => {
          $scope.loading = false;
          ToastsService.success(null, $t('users.new.success'));
          $state.go('main.locations.edit', {
            tab: fromTab || 'users',
          });
        })
        .catch((err) => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function saveUserAndLocation() {
      if ($scope.loading) {
        return;
      }

      $scope.loading = true;
      let user = angular.copy($scope.user);

      // Location model composition
      let location = angular.copy($scope.location);
      location.organizationId = $scope.selectedOrganizationId || $scope.currentOrganization.id;
      if (location.size && !location.size.content) {
        location.size = undefined;
      }
      if ((!$scope.selectedCountry || !$scope.selectedState) && location.state) {
        delete location.state;
      }

      // Phone number parsing
      if (user.phoneNumber) {
        user.phone = user.phoneCode.toString() + user.phoneNumber.toString();
        user.username = user.username ? user.username : user.phone;
        delete user.phoneNumber;
      }
      delete user.phoneCode;

      if (user.password === '') {
        delete user.password;
      }

      return UsersService.createNewUser({
        user: user,
        location: location
      }, void 0, location.organizationId)
        .then((result) => {
          $scope.loading = false;
          ToastsService.success(null, $t('users.new.success'));

          // Redirect to Edit User UI
          user.id = result.userId;
          redirectToEditUser(user);
        }, (err) => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function redirectToEditUser(user) {
      utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, user);
      $state.go('main.users.edit', { userId: user.id });
    }

    function goBack() {
      if (selection === 'organization') {
        $state.go('main.organizations.edit', {
          tab: fromTab || 'admins',
        });
        return;
      } else if (selection === 'location') {
        $state.go('main.locations.edit', {
          tab: fromTab || 'users',
        });
        return;
      } else if (selection === 'notifications') {
        $state.go('main.notifications.groups.edit');
        return;
      }
      $state.go('main.users.list');
    }

    function onSaveAdminUserButtonClick() {
      if ($scope.loading || !$scope.selectedUserRole) {
        return;
      }

      $scope.isSaveAttempt = true;
      triggerFormValidation();
      if (!$('#user-form').form('is valid')) {
        return;
      }
      saveAdminUser();
    }

    function onSaveUserButtonClick() {
      if ($scope.loading) {
        return;
      }
      $scope.isSaveAttempt = true;
      triggerFormValidation();
      if (!$('#user-form').form('is valid')) {
        return;
      }
      saveLocationUser();
    }

    function redirectToOrganization() {
      utils.setStorageItem(SELECTED_ORG_LOCAL_STORAGE_KEY, $scope.selectedOrganization);
      $state.go('main.organizations.edit', { tab: 'admins' });
    }

    function onSaveUserAndLocationButtonClick() {
      if ($scope.loading) {
        return;
      }

      let $locationForm = $('#location-form-2');
      $locationForm.form('validate form');
      if (!$locationForm.form('is valid')) {
        return;
      }
      saveUserAndLocation();
    }

    function onNextStepButtonClick() {
      if ($scope.loading || !!$scope.selectedUserRole) {
        return;
      }

      if ($scope.uiStep === 'user') {
        $scope.isSaveAttempt = true;
        triggerFormValidation();
        if (!$('#user-form').form('is valid')) {
          return;
        }
        $scope.uiStep = 'location';
      } else if ($scope.uiStep === 'location') {
        let $locationForm = $('#location-form');
        $locationForm.form('validate form');
        if (!$locationForm.form('is valid')) {
          return;
        }
        $scope.uiStep = 'location2';
      }
    }

    function onPreviousStepButtonClick() {
      if ($scope.loading) {
        return;
      }

      if ($scope.uiStep === 'location2') {
        $scope.uiStep = 'location';
      } else if ($scope.uiStep === 'location') {
        $scope.uiStep = 'user';
      }
    }

    // #endregion

  }
}

export default angular
  .module('main.usersNew.controller', [])
  .controller('UsersNewController', UsersNewController)
  .name;
